function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeModal, setCurrentVideo } from "@common/actions";
import { API_URL, TOOLTIP_SHOW_DELAY, VOD_CATEGORIES_DEFAULT_OPTIONS, VOD_CATEGORIES_OPTIONS } from "@config/constants";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import ShowCategories from "@common/components/show/ShowCategories";
import request from "@common/services/request";
import { debounce, isEmpty, isNil } from "lodash";
import _ from "lodash";
var VODModal = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(VODModal, Component);
    var _super = _create_super(VODModal);
    function VODModal(props) {
        _class_call_check(this, VODModal);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "playVideo", function(_epg) {
            // Sort by season and episode
            var epg = _object_spread_props(_object_spread({}, _epg), {
                chanId: _epg.id
            });
            _this.props.setCurrentVideo({
                isOpen: true,
                isPlaying: true,
                channelId: epg.chanId,
                allEpgs: _this.sortedEpgs,
                video: {
                    start: epg.start,
                    stop: epg.stop,
                    duration: epg.stop - epg.start,
                    startPosition: -1
                }
            }, true);
            _this.props.closeModal();
        });
        _define_property(_assert_this_initialized(_this), "next", function() {
            var season = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var scrollContainer = document.getElementById("vod-episodes-list-".concat(season));
            if (scrollContainer) {
                var step = scrollContainer.offsetWidth - 388;
                scrollContainer.scrollBy({
                    left: step,
                    behavior: "smooth"
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "prev", function() {
            var season = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var scrollContainer = document.getElementById("vod-episodes-list-".concat(season));
            if (scrollContainer) {
                var step = scrollContainer.offsetWidth - 388;
                scrollContainer.scrollBy({
                    left: -step,
                    behavior: "smooth"
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "renderEpisodes", function(episodes) {
            var season = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            var i18n = _this.props.i18n;
            var onScroll = debounce(function() {
                var currentTarget = document.getElementById("vod-episodes-list-".concat(season));
                _this.setState({
                    seasonsScrollLeft: _object_spread_props(_object_spread({}, _this.state.seasonsScrollLeft), _define_property({}, season, currentTarget.scrollLeft))
                });
            }, 200);
            return /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "vod-episodes-list",
                    id: "vod-episodes-list-".concat(season),
                    onScroll: onScroll,
                    children: episodes.map(function(e) {
                        var _VOD_CATEGORIES_OPTIONS_e_majorId, _VOD_CATEGORIES_OPTIONS_e_majorId1, _VOD_CATEGORIES_OPTIONS_e_majorId2, _VOD_CATEGORIES_OPTIONS_e_majorId3, _e_photos_find, _e_photos, _document_getElementById;
                        var episodeId = "vod-episode-card-".concat(season * 100 + e.numeration.EpisodeNumber);
                        var showEpisodeNameOption = !isEmpty(VOD_CATEGORIES_OPTIONS) && !isNil((_VOD_CATEGORIES_OPTIONS_e_majorId = VOD_CATEGORIES_OPTIONS[e.majorId]) === null || _VOD_CATEGORIES_OPTIONS_e_majorId === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_e_majorId.showEpisodeName) ? (_VOD_CATEGORIES_OPTIONS_e_majorId1 = VOD_CATEGORIES_OPTIONS[e.majorId]) === null || _VOD_CATEGORIES_OPTIONS_e_majorId1 === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_e_majorId1.showEpisodeName : VOD_CATEGORIES_DEFAULT_OPTIONS.showEpisodeName;
                        var realThumbnailsOption = !isEmpty(VOD_CATEGORIES_OPTIONS) && !isNil((_VOD_CATEGORIES_OPTIONS_e_majorId2 = VOD_CATEGORIES_OPTIONS[e.majorId]) === null || _VOD_CATEGORIES_OPTIONS_e_majorId2 === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_e_majorId2.realThumbnails) ? (_VOD_CATEGORIES_OPTIONS_e_majorId3 = VOD_CATEGORIES_OPTIONS[e.majorId]) === null || _VOD_CATEGORIES_OPTIONS_e_majorId3 === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_e_majorId3.realThumbnails : VOD_CATEGORIES_DEFAULT_OPTIONS.realThumbnails;
                        var thumbnail = (_e_photos = e.photos) === null || _e_photos === void 0 ? void 0 : (_e_photos_find = _e_photos.find(function(e) {
                            return e.type === "thumbnail";
                        })) === null || _e_photos_find === void 0 ? void 0 : _e_photos_find.url;
                        if (realThumbnailsOption && !((_document_getElementById = document.getElementById(episodeId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.style.backgroundImage)) {
                            var url = "".concat(API_URL, "/tumblrs/vod/").concat(e.id, "/").concat(String(Math.floor(4 * 60 / 8)).padStart(5, "0"));
                            request({
                                method: "GET",
                                url: url,
                                responseType: "blob"
                            }).then(function(blob) {
                                var imageSource = URL.createObjectURL(blob);
                                document.getElementById(episodeId).style.backgroundImage = "url(".concat(imageSource, ")");
                            });
                        }
                        var episodeName = showEpisodeNameOption ? e.title : "".concat(i18n.common.episode, " ").concat(e.numeration.EpisodeNumber);
                        return /*#__PURE__*/ _jsx("div", {
                            className: "vod-episode-card",
                            id: episodeId,
                            style: {
                                backgroundImage: "url(".concat(thumbnail, ")")
                            },
                            onClick: function() {
                                return _this.playVideo(e);
                            },
                            onKeyDown: function() {
                                return _this.playVideo(e);
                            },
                            "data-tip": e.title,
                            "data-for": "vod-modal-tooltip",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "vod-episode-card-info",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "vod-episode-info",
                                    children: episodeName
                                })
                            })
                        }, e.id);
                    })
                })
            });
        });
        _define_property(_assert_this_initialized(_this), "renderSeries", function() {
            var i18n = _this.props.i18n;
            if (!_this.isSeries) return null;
            // Group epgs by season number
            var seasons = _(_this.sortedEpgs).groupBy(function(e) {
                var _e_numeration;
                return (_e_numeration = e.numeration) === null || _e_numeration === void 0 ? void 0 : _e_numeration.SeasonNumber;
            }).map(function(value, key) {
                return {
                    title: "".concat(i18n.common.season, " ").concat(key),
                    // Sort episodes
                    episodes: value.sort(function(a, b) {
                        return a.numeration.EpisodeNumber - b.numeration.EpisodeNumber;
                    }),
                    id: "season-".concat(key, "-").concat(value[0].id)
                };
            }).value();
            return /*#__PURE__*/ _jsx("div", {
                className: "series-container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "series-content",
                    children: seasons.map(function(season, index) {
                        var scrollContainer = document.getElementById("vod-episodes-list-".concat(index));
                        var scrollLeft = _this.state.seasonsScrollLeft[index] || 0;
                        var arrowBackClasses = scrollLeft <= 0 ? "disabled" : "";
                        var arrowNextClasses = scrollLeft >= ((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollWidth) || 0) - ((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.offsetWidth) || 0) ? "disabled" : "";
                        var showArrows = !(arrowBackClasses === "disabled" && arrowNextClasses === "disabled");
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "series-season",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "season-title",
                                    children: season.title
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "arrows-container",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-arrow-back ".concat(showArrows ? arrowBackClasses : "off"),
                                            onClick: function() {
                                                return _this.prev(index);
                                            },
                                            onKeyDown: function() {
                                                return _this.prev(index);
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-arrow-forward ".concat(showArrows ? arrowNextClasses : "off"),
                                            onClick: function() {
                                                return _this.next(index);
                                            },
                                            onKeyDown: function() {
                                                return _this.next(index);
                                            }
                                        })
                                    ]
                                }),
                                _this.renderEpisodes(season.episodes, index)
                            ]
                        }, season.id);
                    })
                })
            });
        });
        _this.sortedEpgs = _to_consumable_array(_this.props.show.epgs).sort(function(a, b) {
            return a.numeration.SeasonNumber * 100 + a.numeration.EpisodeNumber - (b.numeration.SeasonNumber * 100 + b.numeration.EpisodeNumber);
        });
        _this.state = {
            seasonsScrollLeft: []
        };
        _this.isSeries = _this.sortedEpgs && _this.sortedEpgs.length > 1;
        return _this;
    }
    _create_class(VODModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    seasonsScrollLeft: [
                        0
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _show_photos_find, _show_photos, _this_sortedEpgs, _epg_profiles_, _show_persons_find, _show_persons;
                var _this_props = this.props, i18n = _this_props.i18n, show = _this_props.show;
                var cover = (_show_photos = show.photos) === null || _show_photos === void 0 ? void 0 : (_show_photos_find = _show_photos.find(function(e) {
                    return e.type === "cover";
                })) === null || _show_photos_find === void 0 ? void 0 : _show_photos_find.url;
                var epg = (_this_sortedEpgs = this.sortedEpgs) === null || _this_sortedEpgs === void 0 ? void 0 : _this_sortedEpgs[0];
                var duration = epg.duration;
                var releaseDate = new Date(show.releaseDate);
                var year = releaseDate.getFullYear();
                var rating = show.rating.Overall;
                var description = show.fulltext;
                var quality = (_epg_profiles_ = epg.profiles[0]) === null || _epg_profiles_ === void 0 ? void 0 : _epg_profiles_.name;
                var director = (_show_persons = show.persons) === null || _show_persons === void 0 ? void 0 : (_show_persons_find = _show_persons.find(function(e) {
                    return e.function === "director";
                })) === null || _show_persons_find === void 0 ? void 0 : _show_persons_find.name;
                var actors = show.actors;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "modal vod-modal-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "close-vod-icon-container",
                            children: /*#__PURE__*/ _jsx("span", {
                                onClick: this.props.closeModal,
                                onKeyDown: this.props.closeModal,
                                className: "icon icon-clear-vod pointer"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "vod-modal-content ".concat(this.isSeries ? "series" : ""),
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    id: "vod-modal-tooltip",
                                    className: "tooltip",
                                    delayShow: TOOLTIP_SHOW_DELAY,
                                    place: "bottom",
                                    effect: "solid"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "cover",
                                    style: {
                                        backgroundImage: "url(".concat(cover, ")")
                                    }
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "info-container",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "title",
                                            "data-tip": epg.title,
                                            "data-for": "vod-modal-tooltip",
                                            children: epg.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "categories",
                                            children: /*#__PURE__*/ _jsx(ShowCategories, {
                                                minorCategories: show.minor_categories || show.categories,
                                                majorCategory: show.major_category
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "meta-info-container",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "duration",
                                                    children: duration
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: " \u25CF "
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "year",
                                                    children: year
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: " \u25CF "
                                                }),
                                                quality && /*#__PURE__*/ _jsx("span", {
                                                    className: "quality",
                                                    children: quality
                                                }),
                                                !isEmpty(rating) && /*#__PURE__*/ _jsxs("div", {
                                                    className: "rating-container",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "star-icon"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "current-rating",
                                                            children: rating
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "max-rating",
                                                            children: "/10"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "description",
                                            children: description
                                        }),
                                        (!isEmpty(director) || !isEmpty(actors)) && /*#__PURE__*/ _jsx("div", {
                                            className: "separator"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "cast-info-container",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "cast-info-column",
                                                    children: [
                                                        !isEmpty(director) && /*#__PURE__*/ _jsxs("span", {
                                                            className: "cast-info-name",
                                                            children: [
                                                                i18n.common.director,
                                                                ": "
                                                            ]
                                                        }),
                                                        !isEmpty(actors) && /*#__PURE__*/ _jsxs("span", {
                                                            className: "cast-info-name",
                                                            children: [
                                                                i18n.common.actors,
                                                                ": "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "cast-info-column",
                                                    children: [
                                                        !isEmpty(director) && /*#__PURE__*/ _jsx("span", {
                                                            className: "cast-info-value",
                                                            children: director
                                                        }),
                                                        !isEmpty(actors) && /*#__PURE__*/ _jsx("span", {
                                                            className: "cast-info-value",
                                                            children: actors.join(", ")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "watch-button",
                                            onClick: function() {
                                                return _this.playVideo(epg);
                                            },
                                            onKeyDown: function() {
                                                return _this.playVideo(epg);
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-play"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "button-title",
                                                    children: i18n.common.watch
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                this.renderSeries()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return VODModal;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default withSnackbar(connect(mapStateToProps, {
    closeModal: closeModal,
    setCurrentVideo: setCurrentVideo
})(VODModal));
